export default __webpack_public_path__ + "static/media/mobiledev.9545b09e.jpg";